import Vue from 'vue'
import Router from 'vue-router'
import RouterCommon from './common' // 引入通用模块

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({
    easing: 'ease', // 动画方式
    speed: 500, // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3 // 初始化时的最小百分比
})

Vue.use(Router)

const router = new Router({
    routes: [
        ...RouterCommon,
        {
            path: '/active',
            name: 'active',
            component: resolve => require(['@/pages/active'], resolve),
            meta: {
                title: '活动预约',
                keepAlive: false
            }
        },
        {
            path: '/activeDetails/:active_id',
            name: 'activeDetails',
            component: resolve => require(['@/pages/activeDetails'], resolve),
            meta: {
                title: '活动预约',
                keepAlive: false
            }
        },
        {
            path: '/activeForm/:active_id',
            name: 'activeForm',
            component: resolve => require(['@/pages/activeForm'], resolve),
            meta: {
                title: '活动预约',
                keepAlive: false
            }
        },
        {
            path: '/record',
            name: 'record',
            component: resolve => require(['@/pages/record'], resolve),
            meta: {
                title: '预约记录',
                keepAlive: false
            }
        },
        {
            path: '/recordDetail/:torder_id',
            name: 'recordDetail',
            component: resolve => require(['@/pages/recordDetail'], resolve),
            meta: {
                title: '预约详情',
                keepAlive: false
            }
        },
        {
            path: '/signIn/:active_id/:td_id',
            name: 'signIn',
            component: resolve => require(['@/pages/signIn'], resolve),
            meta: {
                title: '用户签到',
                keepAlive: false
            }
        }
    ]
})

const cancelLastReq = (next) => {
    let axiosPromiseArr = window.__axiosPromiseArr || []
    if (!!axiosPromiseArr && axiosPromiseArr.length) {
        // console.log(axiosPromiseArr)
        let len = axiosPromiseArr.length
        while (len--) {
            axiosPromiseArr[len].cancel('cancel')
            axiosPromiseArr.splice(len, 1)
        }
    }
    next()
}
router.beforeEach((to, from, next) => {
    // 每次切换页面时，调用进度条
    NProgress.start()
    cancelLastReq(next)
})

router.afterEach((to, from) => {
    // 在即将进入新的页面组件前，关闭掉进度条
    NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js